module.exports = __webpack_public_path__ + "img/light-mud-decal-16.4b9fc2d5.png";